// General
import { createContext, useContext, useEffect, useState } from 'react';

const DataContext = createContext();

const DataProvider = ({ children }) => {
  // General Variables
  const [myUser, setMyUser] = useState(null);
  const [sidebarMode, setSidebarMode] = useState(true);
  const [windowMode, setWindowMode] = useState(null);
  const [lastValidationTime, setLastValidationTime] = useState(null);
  const [lastValidation, setLastValidation] = useState(false);
  const [lastValidationRolesInfo, setLastValidationRolesInfo] = useState([]);
  // General Actions
  useEffect(() => { document.documentElement.setAttribute("sidebar-mode", sidebarMode ? 'open' : 'closed'); }, [sidebarMode]);
  const sidebarToggler = () => { setSidebarMode(!sidebarMode) }
  useEffect(() => { if (windowMode === 'web') { setSidebarMode(true); } else { setSidebarMode(false); } }, [windowMode]);
  useEffect(() => {
    const timeout = setTimeout(() => { window.dispatchEvent(new Event('resize')); }, 200);
    return () => clearTimeout(timeout);
  }, [sidebarMode]);
  // Enums
  const deliverydata =['Kargo ile teslimat','Elden Teslimat'];
  const statusdata = ['Aktif', 'Pasif'];
  const userstatusdata = ['Aktif', 'İzinli', 'Silindi'];
  const answerdata = ['Var', 'Yok'];
  const currencydata = ['TRY', 'EUR', 'USD'];
  const citiesdata = ["İstanbul", "Ankara", "İzmir", "Adana", "Adıyaman", "Afyonkarahisar", "Ağrı", "Aksaray", "Amasya", "Antalya", "Ardahan", "Artvin", "Aydın", "Balıkesir", "Bartın", "Batman", "Bayburt", "Bilecik", "Bingöl", "Bitlis", "Bolu", "Burdur", "Bursa", "Çanakkale", "Çankırı", "Çorum", "Denizli", "Diyarbakır", "Düzce", "Edirne", "Elazığ", "Erzincan", "Erzurum", "Eskişehir", "Gaziantep", "Giresun", "Gümüşhane", "Hakkâri", "Hatay", "Iğdır", "Isparta", "Kahramanmaraş", "Karabük", "Karaman", "Kars", "Kastamonu", "Kayseri", "Kırıkkale", "Kırklareli", "Kırşehir", "Kilis", "Kocaeli", "Konya", "Kütahya", "Malatya", "Manisa", "Mardin", "Mersin", "Muğla", "Muş", "Nevşehir", "Niğde", "Ordu", "Osmaniye", "Rize", "Sakarya", "Samsun", "Siirt", "Sinop", "Sivas", "Şanlıurfa", "Şırnak", "Tekirdağ", "Tokat", "Trabzon", "Tunceli", "Uşak", "Van", "Yalova", "Yozgat", "Zonguldak"];
  const cashtransactiontypes = ['Gelir', 'Gider'];
  const cashtransactionsreporttypes = ["Tarihsel", "Yıllık", "Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"];
  // Return
  const values = {deliverydata, myUser, setMyUser, sidebarMode, setSidebarMode, windowMode, setWindowMode, lastValidationTime, setLastValidationTime, lastValidation, setLastValidation, lastValidationRolesInfo, setLastValidationRolesInfo, sidebarToggler, statusdata, userstatusdata, answerdata, currencydata, citiesdata, cashtransactiontypes, cashtransactionsreporttypes }
  return <DataContext.Provider value={values}>{children}</DataContext.Provider>
}

const useData = () => useContext(DataContext);

export { DataProvider, useData };